import { Div } from '@kizi/core-components';
import React from 'react';
import { IconV2 as Icon } from '@kizi/shared-components';
import { useWizardService } from '@kizi/comparator-core';
export const GoBackIconButton = () => {
  const wizard = useWizardService();
  const handleClick = () => {
    wizard?.send({ type: 'GOTO', index: 0 });
  };
  return (
    <Div
      css={{
        display: 'flex',
        padding: '4px',
        borderRadius: '80px',
        background: 'linear-gradient(315deg, #03AD7D 11.93%, #08C98F 81.44%)',
        boxShadow:
          '0px 4px 8px 0px rgba(62, 72, 101, 0.05), 0px 2px 4px 0px rgba(78, 90, 126, 0.10), 0px 4px 8px 0px rgba(0, 0, 0, 0.05)',
        cursor: 'pointer',
      }}
    >
      <Icon name="pencil" size={24} onClick={handleClick} />
    </Div>
  );
};
